// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ReviewsBlock_wrapper__SYONs","addReviewLink":"ReviewsBlock_addReviewLink__UW3N9"};